var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFullscreenVod = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fullscreen",
    transform: "translate(-1823.585 -986.515)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M1856.4,992.765a1.563,1.563,0,0,0,0,3.125h12.5v11.458a1.563,1.563,0,1,0,3.125,0V992.765Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M1840.772,992.765h-15.625v14.583a1.563,1.563,0,1,0,3.125,0V995.89h12.5a1.563,1.563,0,1,0,0-3.125Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M1840.772,1027.14h-12.5v-11.458a1.563,1.563,0,1,0-3.125,0v14.583h15.625a1.563,1.563,0,1,0,0-3.125Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M1833.481,1014.119a1.042,1.042,0,0,0-1.042,1.042v7.812h7.812a1.042,1.042,0,1,0,0-2.083h-4.256l5.774-5.774a1.042,1.042,0,0,0-1.473-1.473l-5.774,5.774v-4.256A1.042,1.042,0,0,0,1833.481,1014.119Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M1870.46,1014.119a1.563,1.563,0,0,0-1.563,1.563v11.458h-12.5a1.563,1.563,0,0,0,0,3.125h15.625v-14.583A1.562,1.562,0,0,0,1870.46,1014.119Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M1855.4,1009.387a1.042,1.042,0,0,0,1.473,0l5.774-5.774v4.256a1.042,1.042,0,0,0,2.084,0v-7.812h-7.813a1.042,1.042,0,1,0,0,2.083h4.256l-5.774,5.774A1.041,1.041,0,0,0,1855.4,1009.387Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 50,
    height: 50,
    transform: "translate(1823.585 986.515)",
    fill: "none"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFullscreenVod, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/fullscreen-vod.219b2c28.svg";
export { ForwardRef as ReactComponent };